import React from "react"
import { BsLinkedin, BsGithub } from "react-icons/bs"
import { FaCodepen } from "react-icons/fa"

const SocialMedia = () => {

  return (
    <div className="app__social">
      <div>
        <BsLinkedin onClick={()=> window.open("https://www.linkedin.com/in/daisyy-le/", "_blank")}/>
      </div>
      <div>
        <BsGithub onClick={()=> window.open("https://github.com/daisyle0203", "_blank")}/>
      </div>
      <div>
        <FaCodepen onClick={()=> window.open("https://codepen.io/daisyle0203", "_blank")}/>
      </div>
    </div>
  )
}

export default SocialMedia
